import { Component } from '@angular/core';

import { LayoutElementComponent } from '../layout-element/layout-element.component';
import { ContentFilterComponent } from '../../content-filter/content-filter.component';

@Component({
    selector: 'layout-filter',
    templateUrl: './layout-filter.component.html',
    styleUrls: ['./layout-filter.component.scss'],
    imports: [ContentFilterComponent]
})
export class LayoutFilterComponent extends LayoutElementComponent {}
